module.exports = __webpack_public_path__ + "static/steve-jobs-bb8b3bdc7a1e5ffb2426f92838344539.jpg";